export const PENDING_EMAIL_SETTINGS_ACTION = 'PENDING_EMAIL_SETTINGS_ACTION'
export const COMPLETED_EMAIL_SETTINGS_ACTION = 'COMPLETED_EMAIL_SETTINGS_ACTION'
export const RESET_EMAIL_SETTINGS_ACTION = 'RESET_EMAIL_SETTINGS_ACTION'
export const SET_EMAIL_SETTINGS_DATA = 'SET_EMAIL_SETTINGS_DATA'
